// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MultiSelect_wrapper__Rh8PD"};